import type {CSSProperties} from 'react';

import {cn} from '../../helpers/cn';

export type DividerProps = {
  color?: string;
  type?: 'horizontal' | 'vertical';
  size?: number;
  width?: number | string;
  height?: number | string;
  isCenter?: boolean;
  className?: string;
};

export function Divider({
  color,
  type = 'horizontal',
  size = 1,
  width,
  height,
  isCenter,
  className
}: DividerProps) {
  const style: CSSProperties = {
    ...(color ? {backgroundColor: color} : {}),
    margin: type === 'horizontal' ? '10px 0' : '0 10px'
  };

  if (type === 'horizontal') {
    style.minHeight = size;
    style.width = width ?? '100%';
  } else {
    style.minWidth = size;
    style.height = height ?? '100%';
  }

  if (isCenter) {
    style.alignSelf = 'center';
  }

  return (
    <div
      role="separator"
      aria-orientation={type}
      className={cn('shrink-0 bg-gray-03', className)}
      style={style}
    />
  );
}
